import styled from 'styled-components';

const MessageContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: flex-end;
  margin-bottom: 10px;
  word-wrap: break-word;
  width: ${props => props.imageWidth};
`;

export default MessageContainer;



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/MessageContainer.js